import promiseClient from 'hub-http/adapters/promiseClient';
import { idpAuthStack } from '../stacks/idpAuthApi';
export default promiseClient(idpAuthStack);